import react, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { Link } from 'react-router-dom';
import '../Styles/homeStyle.css';

const howItWorksData = [
    {
        title: 'At Least 4 Rounds',
        desc:
            'Enroll to participate. Pay a service fee to enter Round 1, then advance through Rounds 2 through at least 4 by paying the posted service fee. When the minimum is met, we call for a Best & Final. Time frames vary. No round-skipping.'
    },
    {
        title: 'Service Fees',
        desc:
            'Service fees accumulate and can be credited to your Best & Final if you win the auction. Non-winners can consult with our offices for future opportunities.'
    },
    {
        title: 'Winner (Huge Savings)',
        desc:
            'Rounds are set by BCA so everyone has a chance. When applicable, BCA provides via a third-party the loan to finalize the sale with at least 5% totaling as a down payment. Interest rates vary but it will be advantageous and favorable. BCA has no buyer’s premium.'
    },
    {
        title: 'Seller',
        desc:
            'Create an auction and submit your item for evaluation. Pay the quoted submission fee. We market your item, set a net price point, run the auction, and settle. Items must be of greater value. No seller’s premium.'
    }
];  

function Home() {
    const [auctionItems, setAuctionItems] = useState([]);
    const [randomItem, setRandomItem] = useState(null);

    useEffect(() => {
        const fetchAuctionItems = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, 'AuctionItems'));
                const now = new Date();
                const sevenDaysAgo = new Date();
                sevenDaysAgo.setDate(now.getDate() - 7);

                const normalizeDate = (date) => {
                    const normalized = new Date(date);
                    normalized.setHours(0, 0, 0, 0);
                    return normalized;
                };

                const items = querySnapshot.docs
                    .map((doc) => ({ id: doc.id, ...doc.data() }))
                    .filter((auction) => {
                        const roundKeys = Object.keys(auction.Rounds || {}).filter(key => key.startsWith('Round'));
                        if (roundKeys.length === 0) return true;
                
                        const sortedRounds = roundKeys
                            .map(key => auction.Rounds[key])
                            .sort((a, b) => new Date(a.endDate) - new Date(b.endDate));

                        const lastRound = sortedRounds[sortedRounds.length - 1];
                        
                        const lastRoundEndDateString = lastRound?.endDate;
                        if (!lastRoundEndDateString) {
                            return true;
                        }

                        const lastRoundEndDate = new Date(lastRoundEndDateString);
                        const normalizedEndDate = normalizeDate(lastRoundEndDate);
                        const normalizedSevenDaysAgo = normalizeDate(sevenDaysAgo);

                        return normalizedEndDate >= normalizedSevenDaysAgo || normalizedEndDate > now;
                    })
                    .filter(item => item.isFeatured === true && item.isApproved === true);

                setAuctionItems(items);

                if (items.length > 0) {
                    const randomIndex = Math.floor(Math.random() * items.length);
                    setRandomItem(items[randomIndex]);
                }
            } catch (error) {
                console.error('Error fetching auction items:', error);
            }
        };

        fetchAuctionItems();
    }, []);

    return (
        <div className="homeContainer">
            <div className="homeContent">
                <div className="header">
                    <div className="text">
                        <div className="sectionKicker">The door has been opened for you.</div>
                        <h1 className="heroTitle">Transparent Auctions <br></br> <span className="mainColorText">Who does it mean more to?</span></h1>
                        <div className="buttonsContainer">
                            <Link
                                to={'/auctions'}
                                style={{ textDecoration: 'none', color: 'white', backgroundColor: '#D6482C', padding: '10px 30px 10px 30px' }}
                            >
                                Browse
                            </Link>

                            <Link 
                                to={`/create-auction`}
                                style={{ textDecoration: 'none', color: 'white', backgroundColor: '#D6482C', padding: '10px 30px 10px 30px' }}
                            >
                                Sell Item
                            </Link>
                        </div>
                    </div>
                    
                    <div className="feature">
                        {randomItem ? (
                            <Link
                                key={randomItem.id} 
                                to={`/auctions/${randomItem.id}`}
                                style={{ textDecoration: 'none' }}
                            >
                                <div className="auctionItemCard">
                                    <img
                                        src={randomItem.Photos[0]}
                                        alt={`Auction item`}
                                        className="auctionPhoto"
                                    />
                                </div>
                            </Link>
                        ) : (
                            <p>No Featured Auction Items Found.</p>
                        )}
                    </div>
                </div>
                <div className="howItWorks"> 
                    <div className="sectionKicker">How it works</div> 
                    <h2 className="sectionTitle">Simple, transparent auctions for everyone</h2> 
                    <ol className="hiwList"> 
                        {howItWorksData.map((item, i) => ( 
                            <li key={item.title} className="hiwRow"> 
                                <span className="hiwIndex">{String(i + 1).padStart(2, '0')}</span> 
                                <h3 className="hiwTitle">{item.title}</h3> 
                                <p className="hiwDesc">{item.desc}</p> 
                            </li> 
                        ))} 
                    </ol> 
                </div>
            </div>
            <div className="featuredAuctionsMap">
                <div className="sectionKicker">Featured Auction Items</div>
                <div className="auctionContainer">
                    {auctionItems.length > 0 ? (
                        auctionItems.map((item) => (
                            <Link
                                key={item.id} 
                                to={`/auctions/${item.id}`}
                                style={{ textDecoration: 'none' }}
                            >
                                <div key={item.id} className="auctionItemCard">
                                    <img
                                        src={item.Photos[0]}
                                        alt={`Auction item`}
                                        className="auctionPhoto"
                                    />
                                    <div className="cardText">
                                        <h2>{item.Name}</h2>
                                        <p>{item.Location}</p>
                                    </div>
                                </div>
                            </Link>
                        ))
                    ) : (
                        <p>No Auction Items Found.</p>
                    )}
                </div>
            </div>

            <Link 
                to={`/create-auction`}
                style={{ textDecoration: 'none' }}
            >
                <button className="createItemBtn">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"/>
                    </svg>
                    Create Auction
                </button>
            </Link>
        </div>
    )
}

export default Home;